/**
 * @desc 获取报告类型
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/monthlyReport/getReportType`, {
      method: "GET",

      ...options,
    }),
  );
}
